// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ticket-item-grid[data-v-1565e2fc]{display:grid;grid-template-columns:90px 210px auto auto;grid-column-gap:10px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);
// Exports
module.exports = exports;
